<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-parker' | translate}}</div>
  <app-parker-registration-detail-parker-details [parker]="registration?.knownTag?.parker"
                                                 [companyName]="registration?.knownTag?.parker?.company?.name"
                                                 [knownTag]="registration?.knownTag"
                                                 [unknowParkerTagFull]="registration?.unknownParkerTagCountryCode ? registration?.unknownParkerTagCountryCode + ' ' + registration?.unknownParkerTagControlPlateNumber : registration?.unknownParkerTagControlPlateNumber">
  </app-parker-registration-detail-parker-details>
</div>

<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-registration' | translate}}</div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.issuer' | translate}}</label>
      <div>{{getRegisteredByText(registration) ?? '-'}}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.entry-type' | translate}}</label>
      <div>{{'i18n.domain.parker-registration.ParkerRegistrationType.' + ParkerRegistrationType[data.type] | translate}}</div>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.timestamp' | translate}}</label>
      <div>{{data.registrationDateTime?.toFormat('dd.MM.yyyy HH:mm:ss') ?? '-'}}</div>
    </div>
    <div class="form-group col-md-6">
      <label class="control-label">{{'i18n.domain.parker-registration.fields.zone' | translate}}</label>
      <div>{{registration?.registeredZoneName ?? '-'}}</div>
    </div>
  </div>
  @if (registration?.mediaFiles?.length && registration?.offense === ParkerRegistrationOffense.NoOffense) {
    <div class="form-row row mb-0">
      <div class="form-group col-md-12">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.media-gallery' | translate}}</label>
        <div class="d-flex align-items-center flex-wrap">
          @for (imageId of registration.mediaFiles; track imageId) {
            <app-async-image [request]="getImageRequest(registration.id, imageId)"></app-async-image>
          }
        </div>
      </div>
    </div>
  }
</div>

<div class="section-card">
  <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-subscription' | translate}}</div>
  @if (registration?.selectedSubscription) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
        <div>{{registration?.selectedSubscription.name ?? '-'}}</div>
      </div>
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription-type' | translate}}</label>
        <div>{{getSubscriptionType(registration?.selectedSubscription) | translate}}</div>
      </div>
    </div>
  }
  @if (!registration?.selectedSubscription) {
    <div class="form-row row">
      <div class="form-group col-md-6 mb-0">
        <label class="control-label">{{'i18n.domain.parker-registration.fields.subscription' | translate}}</label>
        <div>{{'i18n.domain.parker-registration.fields.no-subscription' | translate}}</div>
      </div>
    </div>
  }
</div>

@if (registration && registration.offense !== ParkerRegistrationOffense.NoOffense) {
  <div class="section-card">
    <div class="section-title">{{'i18n.domain.parker-registration.dialog.section-offenses' | translate}}</div>
    <app-parker-registration-detail-offense [offense]="registration" [displayIssuerName]="false"></app-parker-registration-detail-offense>
  </div>
}
